import React from 'react';
import { CSSObject, useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box } from '@mui/material';

/*
*   Боковое меню: верхняя иконка, когда панель раскрыта
*/

type ISideMenuDrawerHeader = {
    openSideMenu: boolean,
    handleSideMenuClick?: () => void,
}

const cssDrawerHeader: CSSObject = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    borderBottom: 'none',
    '& .MuiButtonBase-root ': {
        color: '#666',
    },
};

export default function SideMenuDrawerHeader({ handleSideMenuClick, openSideMenu }: ISideMenuDrawerHeader) {
    const theme = useTheme();
    return (
        <Box sx={{
            ...cssDrawerHeader,
            paddingRight: openSideMenu ? 'none' : '20px',
            ...theme.mixins.toolbar,
        }}>
            <IconButton onClick={handleSideMenuClick}>
                {openSideMenu ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
        </Box>
    );
} 